// 支付宝的跳转中间页面
import React from 'react';
import Url from 'c-url';
import './wechat-redirect.less';

export default class WxpayRedirect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            message: ''
        };
    }

    componentDidMount() {
        let tradeStatus = Url.query('tradeStatus');
        let message = '';

        switch (tradeStatus) {
        case 'A00I':
            message = UG.lang.template('Payment cancelled.');
            break;
        case 'A001': // 订单支付成功
            message = UG.lang.template('Payment has been processed.');
            break;
        default:
            message = UG.lang.template('Payment failed.');
        }
        this.setState({ message });
    }

    goBack() {
        const url = UG.cache.getCache('wxRechargeRedirect');
        UG.cache.removeCache('wxRechargeRedirect');
        if (url) {
            location.replace(url);
        } else {
            location.replace('/gift.html');
        }
    }

    render() {
        const { message } = this.state;
        return (
            <div className="wechat-redirect">
                <img src="http://h.cdn.pengpengla.com/up/uplive/6.0.7/assets/9ff9ad36c846893c14ac9748358527ff.png"/>
                <div>{message}</div>
                <button type="button" className="btn-cus btn-lg" onClick={this.goBack}>
                    {UG.lang.template('Confirm')}
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/component/recharge/tool/wechat-redirect.js